import { useContext } from "react";
import { observer } from "mobx-react-lite";
import validator from "validator";
import { useEffectOnce } from "@lib-shared/hooks";
import { getButtonAnalytics } from "@lib-shared/lib/get-analytics-tags";
import { ButtonToolbar, Form, FormWrapper, Input, SubmitButton } from "@shared-forms";
import { Row } from "@shared/components";
import { AppContext } from "core/app-context";
import { Page } from "core/constants";
import FormCallbackFunc from "core/models/form-callback-func";
import SearchDetails from "core/models/search-details";

type SearchProps = {
    onSubmit: FormCallbackFunc
}

export const isRequired = (message: string, minLength = 1) => {
    return {
        required: {
            value: true,
            message: message
        },
        validate: (value: string) => {
            if (!value || value.length < minLength) {
                return false;
            }

            value = value.trim().split(" ").join("");

            if (value.length < 7) {
                return true;
            }

            return validator.isMobilePhone(value);
        }
    };
};

const SearchForm = observer((props: SearchProps) => {
    const store = useContext(AppContext);
    const { onSubmit } = props;

    const formGroupCssName = "col-md-12 form-floating mb-3";

    const config = {
        searchValue: isRequired("Please enter your Installation Reference Number or Mobile Number", 6)
    };

    const submitForm = (data: SearchDetails) => {
        store.updateSearchDetails(data);
        onSubmit();
    };

    useEffectOnce(() => store.updatePage(Page.search));

    const analytics = getButtonAnalytics("Installation Reference Number", "Submit");

    return (
        <Form cssName="find-form" defaultValues={store.searchDetails} onSubmit={submitForm}>
            <FormWrapper>
                <Row>
                    {store.searchError && <p className="error">{store.searchError}</p>}

                    <Input
                        cssName={formGroupCssName}
                        name="searchValue"
                        label="Installation Reference Number / Mobile Number"
                        fieldOptions={config.searchValue} />
                </Row>
            </FormWrapper>

            <ButtonToolbar>
                <SubmitButton
                    color="primary"
                    disabled={store.isLoading}
                    {...analytics}
                    text="Submit" />
            </ButtonToolbar>
        </Form>
    );
});

export default SearchForm;
